import React from 'react';
import { Box, Typography } from '@mui/material';
import { AppColors } from '../utils/utils';

interface SectionHeaderProps {
  text: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ text }) => {
  return (
    <Box
      sx={{
        px: '20px',
        py: '8px',
        background: AppColors.aiGradientTransparent2,
        borderRadius: '20px',
      }}
    >
      <Typography
        fontWeight={500}
        textAlign='center'
        sx={{
          background: AppColors.textGradient,
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          fontSize: 'clamp(0.74rem, 1.5vw, 0.875rem)',
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
